import numeral from 'numeral';

export const formatNumber = (price) => {
  return numeral(price).format('0,0.00');
};

export const showPrice = (price, currency='$') => {
  return price ? `${currency}${formatNumber(price)}` : '-';
};

export const getTotal = (items = []) => {
  let value = 0;
  items.forEach((item) => {
    if (item.stock > 0)
      value = value + (item.quantity * item.price);
  });
  return value;
};

export const showSaving = (price, lastPrice) => {
  return lastPrice ? `$${formatNumber(+lastPrice - +price)} (${formatNumber((+lastPrice - +price) * 100 / +lastPrice)}%)` : '-';
};

export const scrollToPosition = (value = 0) => {
  document.body.scrollTop = value; // For Safari
  document.documentElement.scrollTop = value;
};

export const getFileName = (value) => {
  if (!value) return '';
  const paths = value.split('/');
  return paths[paths.length - 1];
};

export const showCard = (value) => {
  return '**** **** **** ' + value.substr(-4);
};
